import {h, Fragment} from "preact"
export default function ImageFilters({ facet, toggleFilter, images }) {
    
    return (
        <ul class="ns-facet__images-filter-list ns-flex ns-flex-wrap">
            {facet.data?.map(value => {
                const filterImage = images[value.value];

                return ((filterImage && filterImage !== "") &&
                    <li
                        class={`ns-image-filter ns-relative ns-flex ns-justify-between ${value.selected ? "ns-checked" : ""}`}
                        data-nosto-element="facet-setting"
                    >
                        <label className="ns-image-filter__label ns-w-full ns-flex ns-flex-col ns-items-center">
                            <div className="ns-image-filter__img-wrap">
                                <img 
                                    className="ns-image-filter__img ns-block"
                                    src={filterImage.replace('.jpg', '_250x.jpg').replace('.png', '_250x.png').replace('.webp', '_250x.webp')}
                                    alt={`Image for filter ${value.value}`}
                                    width="100"
                                    height="125"
                                    loading="lazy"
                                />
                            </div>
                            <span className="ns-image-filter__text ns-flex ns-justify-center">
                                {value.value}
                            </span>
                            <input
                                className="ns-image-filter__input"
                                type="checkbox" 
                                checked={value.selected} 
                                onChange={e => {
                                    e.preventDefault()
                                    toggleFilter(facet.field, value.value, !value.selected)
                                }} 
                            />
                        </label>
                    </li>
                )
            })}
        </ul>
    )
}